<template lang="pug">
v-container.full-height.align-center.justify-center.d-flex
  v-card(outlined width="600px").pa-4
    h1.mb-4 404 - Запрашиваемый ресурс не найден
    p.mb-4 В адресе есть ошибка или страница удалена

    router-link(to="/")
      v-btn(color="primary") Перейти на главную

</template>

<script>
export default {
};
</script>
